<template>
  <v-app>
    <Navbar ref="navbar" @run="run" />

    <v-content class="d-flex align-stretch align-items-stretch white">
      <router-view 
        class="d-flex pt-3"
        @message="message" 
        @run="run"
      ></router-view>
    </v-content>

    <v-footer app />

    <div class="text-center ma-2">
      <v-snackbar
        v-model="snackbar.show"
        dark
        top
      >
        {{ snackbar.text }}
        <v-btn
          text
          @click="snackbar.show = false"
        ><v-icon left>mdi-close</v-icon></v-btn>
      </v-snackbar>
    </div>
    <Footer />
  </v-app>
</template>

<script>
import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'

export default {
  name: 'App',
  components: {
    Navbar,
    Footer,
  },
  computed: {
    //user() { return this.$store.state.authentication.user },
  },
  data: () => ({
    allowedDomains: [
      'lacartoucherie.com'
    ],
    progress: false,
    snackbar: {
      show: false,
      text: null,
    },
  }),
  methods: {
    run(method, params) {
      if(typeof this[method] === 'function') {
        Boolean(params) ? this[method](params) : this[method]()
      }
    },
    /* progressing(value) {
      this.progress = value
      return
    }, */
    newDialog(message) {
      this.dialog = {
        show: true,
        title: message.title,
        text: message.text,
        callback: message.callback,
      }
    },
    message(msg) {
      this.snackbar = {
        show: true,
        text: msg,
      }
    },
    clearDialog() {
      this.dialog = {
        show: false,
        title: null,
        text: null,
      }
    },
  }, 
  created() {
    this.$store.dispatch('init', ['auth'])
  },
  destroyed() {
    this.$store.dispatch('close')
    this.$store.dispatch('auth/signOut')
      .then(() => {
        if(this.$route.path !== '/') this.$router.push({ path: '/' })
        else this.$router.go()
      })
  },
}
</script>

<style>
.v-content__wrap {
  position: relative;
}

.v-content__wrap > * {
  height: 100%;
}

.v-tabs-items > div,
.v-tabs-items > div > div.v-window-item--active,
.v-tabs-items > div > div.v-window-item--active > div.v-card {
  height: 100%;
  width: 100%;
}

.clickable,
.clickable-table > * > * > * > tr {
  cursor: pointer;
}

.color-gradient {
    background: rgb(0,188,212);
    background: linear-gradient(90deg, rgba(0,188,212,1) 0%, rgba(252,176,69,1) 50%, rgba(255,0,255,1) 100%);
}

.monochrome-gradient {
  background: rgb(0,0,0);
  background: linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(117,117,117,1) 100%);
}

.v-stepper{
    box-shadow: none !important;
}

.v-stepper__label {
  width: 100%;
}

.deep-border {
  border: 3px solid #311B92
}
</style>